var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label",style:({color: _vm.rowData.color, backgroundColor: _vm.rowData.background_color, fontSize: '1.25rem'}),attrs:{"id":"example"},on:{"click":function($event){$event.preventDefault();return _vm.toggleDetailRow($event)}}},[_vm._v("\n    "+_vm._s(_vm.rowData.name)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6ddc3ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Sources/SourceLabel.vue
// module id = 1dCn
// module chunks = 0